'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { InternalProvider, useId } from '../../util';
import { DropdownContainer, DropdownSelect, DropdownLabel, Chevron, HelperText, DropdownWrapper } from './elements';
export const Dropdown = /*#__PURE__*/React.forwardRef(({
  options,
  label = '',
  name = '',
  id,
  selectClassName = '',
  labelClassName = '',
  containerClassName = '',
  value = '',
  helperText = '',
  fieldStatus = 'default',
  disabled = false,
  className,
  ...restProps
}, fRef) => {
  const dropdownId = useId('dropdown', id);
  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(DropdownWrapper, {
    className: className
  }, /*#__PURE__*/React.createElement(DropdownContainer, {
    fieldStatus: fieldStatus,
    className: containerClassName,
    id: `${dropdownId}-container`,
    "data-aui": "dropdown"
  }, /*#__PURE__*/React.createElement(DropdownSelect, _extends({
    name: name,
    id: dropdownId,
    ref: fRef,
    value: value,
    className: selectClassName,
    validOptionSelected: value !== '',
    fieldStatus: fieldStatus,
    disabled: disabled
  }, restProps), label && /*#__PURE__*/React.createElement("option", {
    key: "",
    value: "",
    disabled: true
  }), options.map((item, index) => /*#__PURE__*/React.createElement("option", {
    key: `${index}-${item.value}`,
    value: item.value
  }, item.name))), /*#__PURE__*/React.createElement(DropdownLabel, {
    validOptionSelected: value !== '',
    htmlFor: dropdownId,
    id: `${dropdownId}-label`,
    className: labelClassName
  }, label), /*#__PURE__*/React.createElement(Chevron, null)), helperText && /*#__PURE__*/React.createElement(HelperText, {
    className: "dropdown_helper_text",
    fieldStatus: fieldStatus
  }, helperText)));
});